var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCordovaSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cordova") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.18,21.55H16.94l.23-2.73H15.58l-.23,2.73H8.65l-.23-2.73H6.83l.23,2.73H3.82L2,9.73,6.55,2.45h10.9L22,9.73,20.18,21.55M16.55,6.09H13.62l.2,1.36H10.18l.2-1.36H7.45L5.64,9.73,6.55,17h10.9l.91-7.27L16.55,6.09M15,14.59c-.25,0-.45-.76-.45-1.69s.2-1.7.45-1.7.46.76.46,1.7-.2,1.69-.46,1.69m-5.73.14C9,14.73,8.76,14,8.76,13s.2-1.69.46-1.69.45.75.45,1.69S9.47,14.73,9.22,14.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordovaSvgrepoCom);
export default __webpack_public_path__ + "static/media/cordova-svgrepo-com.32543008aab3328f463669344367344c.svg";
export { ForwardRef as ReactComponent };